import { Controller } from "@hotwired/stimulus"

/**
 * Swaps a button/link to a loading spinner on click.
 * Automatically resets when a Turbo stream response is received.
 */
export default class extends Controller<HTMLElement> {
  private originalHTML = ""

  start(): void {
    this.originalHTML = this.element.innerHTML
    this.element.classList.add("pointer-events-none", "opacity-70")
    this.element.innerHTML =
      '<span class="loading loading-spinner loading-xs"></span> Generating…'

    // Reset when the turbo stream response arrives
    document.addEventListener("turbo:before-stream-render", this.reset, {
      once: true,
    })
  }

  private reset = (): void => {
    this.element.innerHTML = this.originalHTML
    this.element.classList.remove("pointer-events-none", "opacity-70")
  }

  disconnect(): void {
    document.removeEventListener("turbo:before-stream-render", this.reset)
  }
}
